(function () {
  var IP = window.IPSections;
  if (!IP) return;

  var toArray = IP.toArray;
  var markReady = IP.markReady;
  var readFloat = IP.readFloat;

  function initInstagramFeed(section) {
    if (!markReady(section, 'ready')) return;

    var modal = section.querySelector('[data-instagram-modal]');
    var scrollContainer = section.querySelector('[data-instagram-scroll]');
    var openButtons = section.querySelectorAll('[data-instagram-open]');
    var closeButtons = section.querySelectorAll('[data-instagram-close]');
    var closeButton = section.querySelector('.ip-instagram-modal__close');
    var previousButton = section.querySelector('[data-instagram-prev]');
    var nextButton = section.querySelector('[data-instagram-next]');
    var modalPosts = scrollContainer ? scrollContainer.querySelectorAll('[data-instagram-modal-post]') : [];
    var lastFocused = null;
    var currentIndex = 0;

    if (!modal || !openButtons.length) return;

    function pauseModalVideos() {
      toArray(modal.querySelectorAll('video')).forEach(function (video) {
        video.pause();
      });
    }

    function normalizePostIndex(index) {
      var count = modalPosts.length || openButtons.length;
      var parsed = parseInt(index, 10);

      if (!count) return 0;
      if (isNaN(parsed)) return 0;

      return ((parsed % count) + count) % count;
    }

    function showPost(index) {
      currentIndex = normalizePostIndex(index);

      toArray(modalPosts).forEach(function (post, index) {
        var isActive = index === currentIndex;

        post.classList.toggle('is-active', isActive);
        post.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      if (scrollContainer) scrollContainer.scrollTop = 0;
    }

    function goToPost(index) {
      pauseModalVideos();
      showPost(index);
    }

    function openModal(index) {
      lastFocused = document.activeElement;
      pauseModalVideos();
      showPost(index);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ip-instagram-modal-open');

      window.setTimeout(function () {
        if (closeButton) closeButton.focus();
      }, 0);
    }

    function closeModal() {
      if (!modal.classList.contains('is-open')) return;

      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ip-instagram-modal-open');
      pauseModalVideos();

      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    toArray(openButtons).forEach(function (button) {
      button.addEventListener('click', function () {
        openModal(button.getAttribute('data-instagram-open'));
      });
    });

    toArray(closeButtons).forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    if (previousButton) {
      previousButton.addEventListener('click', function () {
        goToPost(currentIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        goToPost(currentIndex + 1);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal();
      if (!modal.classList.contains('is-open')) return;
      if (event.key === 'ArrowLeft') goToPost(currentIndex - 1);
      if (event.key === 'ArrowRight') goToPost(currentIndex + 1);
    });
  }
  IP.register('ip-instafeed', '[data-ip-instagram-feed]', function (section) {
    initInstagramFeed(section);
    IP.initReveal(section);
  });
})();
